// Drops one-time secrets from the address bar so they never reach history,
// referrers or analytics page views.
export const scrubLocationSecrets = (keys: string[]) => {
  if (typeof window === "undefined") {
    return;
  }
  const url = new URL(window.location.href);
  let changed = false;
  for (const key of keys) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      changed = true;
    }
  }
  if (url.hash.includes("token=")) {
    url.hash = "";
    changed = true;
  }
  if (changed) {
    window.history.replaceState(window.history.state, "", url.toString());
  }
};
